
import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import { getUser, ifSave } from '../api';
import qs from 'qs';
import { isWeiXin } from '@/common/ts/common';
import { List, Lazyload, Dialog, Toast } from 'vant';
Vue.use(List).use(Lazyload).use(Dialog).use(Toast);
@Component({
  components: {
    SearchBar,
  },
})
export default class User extends Vue {
  search = '';
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  unionid: string | null = '';
  async mounted() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  // WechatLogin() {
  //   const { code, source } = qs.parse(location.search, {
  //     ignoreQueryPrefix: true,
  //   });
  //   if (isWeiXin() && !code) {
  //     const appId = 'wx1949ed4a473b87ed';
  //     location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
  //       location.href,
  //     )}`;
  //   }
  // }
  WechatLogin() {
    const unionid = window.localStorage.getItem('unionid');
    if (!unionid) {
      if (isWeiXin() || !window.udid) {
        const appId = 'wx1949ed4a473b87ed';
        location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
          location.href,
        )}`;
      }
    }
  }
  onLoad() {
    const data = {
      unionid: this.unionid,
      token: window.gettoken(),
      appkey: window.appkey,
      wdid: window.udid,
    };
    getUser(data).then((res: any) => {
      this.list = res.data;
      this.finished = true;
      this.finished = true;
    });
  }
  goDetail(id: any, enable: string) {
    if (enable === '1') {
      this.$router.push(`homeDetail?id=${id}`);
    }
  }
}
